/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CorrectRecordingRequestEditsInner } from './CorrectRecordingRequestEditsInner';
import {
    CorrectRecordingRequestEditsInnerFromJSON,
    CorrectRecordingRequestEditsInnerFromJSONTyped,
    CorrectRecordingRequestEditsInnerToJSON,
} from './CorrectRecordingRequestEditsInner';

/**
 * 
 * @export
 * @interface CorrectRecordingRequest
 */
export interface CorrectRecordingRequest {
    /**
     * 
     * @type {Array<CorrectRecordingRequestEditsInner>}
     * @memberof CorrectRecordingRequest
     */
    edits: Array<CorrectRecordingRequestEditsInner>;
}

/**
 * Check if a given object implements the CorrectRecordingRequest interface.
 */
export function instanceOfCorrectRecordingRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "edits" in value;

    return isInstance;
}

export function CorrectRecordingRequestFromJSON(json: any): CorrectRecordingRequest {
    return CorrectRecordingRequestFromJSONTyped(json, false);
}

export function CorrectRecordingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectRecordingRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'edits': ((json['edits'] as Array<any>).map(CorrectRecordingRequestEditsInnerFromJSON)),
    };
}

export function CorrectRecordingRequestToJSON(value?: CorrectRecordingRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'edits': ((value.edits as Array<any>).map(CorrectRecordingRequestEditsInnerToJSON)),
    };
}

